import type { InvitationModel } from '@/adapters/apiv1.g';
import type { Invitation } from '@/types/core/member';
import type { UUID } from '@/utils/uuid';

export function extractInvitation(model: InvitationModel): Invitation {
  return {
    invitationId: model.invitation_id as UUID | undefined,
    email: model.email,
    status: model.status,
    acceptedAt: model.accepted_at,
    declinedAt: model.declined_at,
    sentAt: model.sent_at,
    tenantId: model.tenant_id as UUID | undefined,
    userId: model.user_id as UUID | undefined,
  };
}
